import React, { useEffect, useReducer, useState } from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowRightRoundedIcon from "@material-ui/icons/KeyboardArrowRightRounded";
import Link from "@material-ui/core/Link";
import NotificationsRoundedIcon from "@material-ui/icons/NotificationsRounded";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";

import NotificationContext from "../../context/notification-context";
import notificationReducer from "../../reducers/notification-reducer";
import { getNotificationItems } from "../../actions/notification-actions";
import NotificationPopoverHolder from "./NotificationPopoverHolder";

import useStyles from "../../styles/components/notification/stylesNotificationPopover";

const NotificationPopover = () => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [notificationContext, dispatch] = useReducer(notificationReducer);
    const [notification, setNotification] = useState([]);
    const [page, setPage] = useState(10)
    const history = useHistory();

    useEffect(() => {
        const initNotifications = async () => {
            const response = await getNotificationItems();
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }
            setNotification(response.data);
        };

        initNotifications();
    }, []);

    const handleClick = (event) => setAnchorEl(event.currentTarget);

    const handleClose = () => setAnchorEl(null);

    const handleCountNotification = () => {
        let count = 0;
        notification &&
            notification.forEach((element) => {
                if (!element.isRead) {
                    count += 1;
                }
            });
        return count;
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
        <NotificationContext.Provider value={{ notificationContext, dispatch }}>
            <IconButton
                edge="start"
                classes={{ root: classes.rootIcon }}
                color="inherit"
                aria-label="menu"
                onClick={handleClick}
            >
                <NotificationsRoundedIcon />
                <Typography
                    variant="body1"
                    classes={{ root: classes.rootQuantityUnder }}
                >
                    {handleCountNotification() > 5
                        ? `5+`
                        : handleCountNotification()}
                </Typography>
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                transitionDuration={5}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                classes={{
                    root: classes.rootContain,
                    paper: classes.paperContain,
                }}
            >
                <Grid container classes={{ root: classes.rootBody }}>
                    <Grid
                        container
                        justify="center"
                        alignItems="center"
                        classes={{ root: classes.rootHeader }}
                    >
                        <Grid
                            container
                            item
                            xs={6}
                            justify="flex-start"
                            alignItems="center"
                        >
                            <Typography variant="body1" classes={{ root: classes.rootTitle }}>
                                Notifications
                            </Typography>
                            <Grid
                                container
                                justify="center"
                                classes={{ root: classes.rootQuantityContain }}
                            >
                                <Typography
                                    variant="body1"
                                    classes={{ root: classes.rootQuantity }}
                                >
                                    {handleCountNotification() > 5
                                        ? `5+`
                                        : handleCountNotification()}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={6}
                            justify="flex-end"
                            alignItems="center"
                            classes={{ root: classes.rootGridContainerIcon }}
                        >
                            <div>
                                <Link style={{ cursor: "pointer" }} onClick={() => history.push("/Notification")} classes={{ root: classes.rootLink }}>
                                    See all
                                </Link>
                            </div>
                            <div className={classes.containerIcon}>
                                <KeyboardArrowRightRoundedIcon />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid aria-label="main mailbox folders"
                        classes={{ root: classes.rootList }}
                    >
                        {notification &&
                            notification.slice(0, page).map((item, index) => (
                                <NotificationPopoverHolder key={index} notification={item} />
                            ))}
                    </Grid>
                    {
                        notification.length >= page &&
                        <Grid
                            container
                            justify="center"
                            alignItems="center"
                            onClick={() => setPage(page + 20)}
                            classes={{ root: classes.conainerShowMore }}
                        >
                            <div className={classes.buttonShowMore}>
                                Load More
                        </div>
                        </Grid>
                    }

                </Grid>
            </Popover>
        </NotificationContext.Provider>
    );
};

export default NotificationPopover;